// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const HeaderAccount: React.FC<{ size?: number; color1?: string; className?: string }> = ({ size = 20, className }) => (
    <svg className={className} focusable="false" viewBox="0 0 20 20" width={size} height={size}>
        <path
            fill="currentColor"
            d="M15.793 16.335a4.75 4.75 0 0 0-4.605-3.585H8.813a4.75 4.75 0 0 0-4.606 3.585 8.313 8.313 0 1 1 14.105-5.96c0 2.338-.964 4.45-2.52 5.96m-1.058.868A8.24 8.24 0 0 1 10 18.688a8.3 8.3 0 0 1-4.739-1.481 3.563 3.563 0 0 1 3.552-3.27h2.375c1.87 0 3.399 1.44 3.55 3.27zM10 19.875a9.5 9.5 0 1 0 0-19 9.5 9.5 0 0 0 0 19m0-9.5a1.781 1.781 0 1 1 0-3.562 1.781 1.781 0 0 1 0 3.562M7.031 8.594a2.969 2.969 0 1 0 5.938 0 2.969 2.969 0 0 0-5.938 0"
        />
    </svg>
);

export default React.memo(HeaderAccount);
